import React from 'react';
import { AdjustmentsIcon, XIcon } from '@heroicons/react/outline';

type Props = {
  onDecline: () => void;
  onAccept: () => void;
};

const CookieBanner: React.FC<Props> = ({ onDecline, onAccept }) => {
  return (
    <div className="fixed bottom-0 inset-x-0 pb-2 sm:pb-5" style={{ zIndex: 300 }}>
      <div className="max-w-7xl mx-auto px-2 sm:px-6 lg:px-8">
        <div className="p-2 rounded-lg bg-xp-lightgreen-500 shadow-lg sm:p-3">
          <div className="flex items-center justify-between flex-wrap">
            <div className="w-0 flex-1 flex items-center">
              <span className="flex p-2 rounded-lg bg-xp-lightgreen-800">
                <AdjustmentsIcon className="h-6 w-6 text-white" aria-hidden="true" />
              </span>
              <p className="ml-3 font-medium text-white">
                <span className="md:hidden">Xplore uses cookies to analyse user behaviour in order to constantly improve the website.</span>
                <span className="hidden md:inline">Xplore uses cookies to analyse user behaviour in order to constantly improve the website.</span>
              </p>
            </div>
            <div className="order-3 mt-2 flex-shrink-0 w-full sm:order-2 sm:mt-0 sm:w-auto">
              <a
                onClick={onAccept}
                href="#"
                className="flex items-center justify-center px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-xp-lightgreen-600 bg-white hover:bg-xp-lightgreen-50">
                Accept
              </a>
            </div>
            <div className="order-2 flex-shrink-0 sm:order-3 sm:ml-2">
              <button
                type="button"
                className="-mr-1 flex p-2 rounded-md hover:bg-xp-lightgreen-500 focus:outline-none focus:ring-2 focus:ring-white"
                onClick={onDecline}>
                <span className="sr-only">Dismiss</span>
                <XIcon className="h-6 w-6 text-white" aria-hidden="true" />
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookieBanner;
